/**
 * Icônes SVG inline.
 *
 * Pas d'emoji (rendu variable selon les plateformes, ici un carré vide) et pas
 * de fichier distant : quelques tracés `currentColor` suffisent, et la CSP
 * n'autorise que l'origine de toute façon.
 */
const NS = 'http://www.w3.org/2000/svg';

function svg(paths: string[], size = 16, label?: string): SVGSVGElement {
  const el = document.createElementNS(NS, 'svg');
  el.setAttribute('viewBox', '0 0 24 24');
  el.setAttribute('width', String(size));
  el.setAttribute('height', String(size));
  el.setAttribute('fill', 'none');
  el.setAttribute('stroke', 'currentColor');
  el.setAttribute('stroke-width', '2');
  el.setAttribute('stroke-linecap', 'round');
  el.setAttribute('stroke-linejoin', 'round');
  el.setAttribute('focusable', 'false');
  el.setAttribute('aria-hidden', label ? 'false' : 'true');
  if (label) {
    el.setAttribute('role', 'img');
    el.setAttribute('aria-label', label);
  }
  for (const d of paths) {
    const path = document.createElementNS(NS, 'path');
    path.setAttribute('d', d);
    el.appendChild(path);
  }
  return el;
}

/** Cadenas : lecture seule. */
export function lockIcon(size = 16): SVGSVGElement {
  return svg(['M6 10V7a6 6 0 0 1 12 0v3', 'M5 10h14v10H5z', 'M12 14v2'], size);
}

/** Triangle d'avertissement : écart XMP / BT-24. */
export function warningIcon(size = 14): SVGSVGElement {
  return svg(['M12 3 2.5 20.5h19L12 3Z', 'M12 9.5v4.5', 'M12 17.2v.1'], size);
}

/** Fichier : rappel visuel du nom de fichier. */
export function fileIcon(size = 14): SVGSVGElement {
  return svg(['M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8Z', 'M14 3v5h5'], size);
}

/** Flèche vers un plateau : « glissez la facture » (zone de dépôt). */
export function dropHereIcon(size = 16): SVGSVGElement {
  return svg(['M12 3v11', 'M7.5 9.5 12 14l4.5-4.5', 'M4 15v4h16v-4'], size);
}
